import { createTheme } from '@mui/material/styles';

const navy = '#0B1D4A';
const green = '#7CB342';

const softShadow = [
  'none',
  '0 1px 2px rgba(11, 29, 74, 0.04)',
  '0 2px 8px rgba(11, 29, 74, 0.06)',
  '0 4px 16px rgba(11, 29, 74, 0.08)',
  '0 8px 24px rgba(11, 29, 74, 0.10)',
  '0 12px 32px rgba(11, 29, 74, 0.12)',
  '0 16px 40px rgba(11, 29, 74, 0.14)',
];
while (softShadow.length < 25) {
  softShadow.push(softShadow[softShadow.length - 1]);
}

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: navy,
      light: '#1A3A7A',
      dark: '#061230',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: green,
      light: '#9CCC65',
      dark: '#558B2F',
      contrastText: navy,
    },
    background: {
      default: '#F0F3F8',
      paper: '#FFFFFF',
    },
    text: {
      primary: navy,
      secondary: '#5A6A85',
    },
    divider: 'rgba(11, 29, 74, 0.08)',
    success: { main: '#2E7D32' },
    error: { main: '#C62828' },
    warning: { main: '#EF6C00' },
    info: { main: '#1565C0' },
  },
  typography: {
    fontFamily: '"Manrope", "Montserrat", system-ui, sans-serif',
    h1: { fontWeight: 800, letterSpacing: '-0.03em' },
    h2: { fontWeight: 800, letterSpacing: '-0.02em' },
    h3: { fontWeight: 750, letterSpacing: '-0.02em' },
    h4: { fontWeight: 750, letterSpacing: '-0.02em' },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    subtitle1: { fontWeight: 650 },
    subtitle2: { fontWeight: 650 },
    button: { fontWeight: 700, textTransform: 'none', letterSpacing: '0.01em' },
    body1: { lineHeight: 1.6 },
    body2: { lineHeight: 1.55 },
  },
  shape: { borderRadius: 14 },
  shadows: softShadow,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: '#F0F3F8' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 11,
          paddingInline: 18,
          boxShadow: 'none',
          '&:hover': { boxShadow: '0 6px 18px rgba(11, 29, 74, 0.16)' },
        },
        containedPrimary: {
          background: `linear-gradient(135deg, ${navy} 0%, #163A7A 100%)`,
        },
        containedSecondary: {
          color: navy,
          fontWeight: 750,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid rgba(11, 29, 74, 0.06)',
        },
        elevation0: { border: '1px solid rgba(11, 29, 74, 0.06)' },
        elevation1: { boxShadow: '0 2px 12px rgba(11, 29, 74, 0.05)' },
        elevation2: { boxShadow: '0 6px 20px rgba(11, 29, 74, 0.08)' },
        elevation3: { boxShadow: '0 10px 28px rgba(11, 29, 74, 0.1)' },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 18,
          border: '1px solid rgba(11, 29, 74, 0.08)',
          boxShadow: '0 24px 60px rgba(11, 29, 74, 0.18)',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontWeight: 750,
          letterSpacing: '-0.01em',
          borderBottom: '1px solid rgba(11, 29, 74, 0.06)',
          paddingBottom: 16,
        },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined', size: 'medium' },
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 11,
            backgroundColor: '#fff',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 11 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 650, borderRadius: 8 },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            fontWeight: 750,
            backgroundColor: '#F5F7FB',
            color: navy,
            borderBottom: '1px solid rgba(11, 29, 74, 0.08)',
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover': { backgroundColor: 'rgba(11, 29, 74, 0.025)' },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: 650,
          minHeight: 48,
          textTransform: 'none',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          height: 3,
          borderRadius: 3,
          backgroundColor: green,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: { boxShadow: 'none' },
      },
    },
  },
});

export default theme;
